import { SorXMetadataFull } from "datatypes/SorXFormat";
import { Point2 } from "libraries/DataTypes/Point2";
import { ICamIV64File } from "services/Hardware/CamHTTP/CamIV64File";
import { IndustrialCamIV64MockMeasurements } from "./IndustrialCamIV64MockMeasurements";

export class IndustrialCamIV64Mock {
    public static files(): ICamIV64File[] {
        const rootDirectory = "UserData";

        const files: string[] = [];
        for (let i = 0; i < 20; i++) {
            const fileName = `Leak Inspection/leak_${i}.sorx`;
            files.push(fileName);
        }

        for (let i = 0; i < 20; i++) {
            const fileName = `Partial Discharge/pd_${i}.sorx`;
            files.push(fileName);
        }

        // A week ago
        const date = new Date();
        date.setDate(date.getDate() - 7);
        return files.map((file) => {
            return { filePath: `${rootDirectory}/${file}`, createDate: date } as ICamIV64File;
        });
    }
    public static favoriteMeasurements(): ICamIV64File[] {
        const rootDirectory = "UserData";
        const files: string[] = [];
        for (let i = 0; i < 3; i++) {
            const fileName = `Leak Inspection/leak_${i}.sorx`;
            files.push(fileName);
        }

        for (let i = 0; i < 2; i++) {
            const fileName = `Partial Discharge/pd_${i}.sorx`;
            files.push(fileName);
        }

        // A week ago
        const date = new Date();
        date.setDate(date.getDate() - 7);
        return files.map((file) => {
            return { filePath: `${rootDirectory}/${file}`, createDate: date } as ICamIV64File;
        });
    }

    public static measurementBlob(filePath: string): Blob {
        return new Blob([new Uint8Array()], { type: "application/octet-stream" });
    }

    public static sorxMeasurementMetadata(filePath: string): SorXMetadataFull {
        const imageBase64 =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=";
        const featureImages = [
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVR42mP8//8/AwAI/wM+z4AAAAASUVORK5CYII=",
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=",
        ];
        const pulseCount = 100;
        const dischargeDataPoints: Point2[] = [
            { x: 0.1, y: 0.5 },
            { x: 0.2, y: 0.7 },
            { x: 0.3, y: 0.9 },
            { x: 0.4, y: 1.1 },
            { x: 0.5, y: 1.3 },
            { x: 0.6, y: 1.5 },
            { x: 0.7, y: 1.7 },
            { x: 0.8, y: 1.9 },
            { x: 0.9, y: 2.1 },
            { x: 1.0, y: 2.3 },
        ];

        const additionalSorXMetadata = {
            image: imageBase64,
            featureImages: featureImages,
        };

        if (filePath.includes("leak")) {
            // Example SorXMetadata for Leak Inspection with the new common metadata format
            const sorXmetadata = IndustrialCamIV64MockMeasurements.leakInspection;
            return {
                ...sorXmetadata,
                ...additionalSorXMetadata,
            } as SorXMetadataFull;
        } else if (filePath.includes("pd") || filePath.includes("partial")) {
            const sorXmetadata = IndustrialCamIV64MockMeasurements.partialDischargeInspection;
            return {
                ...sorXmetadata,
                ...additionalSorXMetadata,
                prpdBinData: { pulseCount: pulseCount, dischargeDataPoints: dischargeDataPoints },
            } as SorXMetadataFull;
        }
    }
}
